import { render, staticRenderFns } from "./ImportEcosystems.vue?vue&type=template&id=70814c9e&scoped=true"
import script from "./ImportEcosystems.vue?vue&type=script&lang=js"
export * from "./ImportEcosystems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70814c9e",
  null
  
)

export default component.exports